import React from 'react'
import { Popconfirm, Button } from 'antd'

export const SupplyHistoryActions = ({ data, cancelLoadingState, onRunCancel }) => {
  const isLoading = cancelLoadingState.loading && data.id === cancelLoadingState.historyId
  return (
    <Popconfirm
      title='Are you sure to cancel this run?'
      onConfirm={() => onRunCancel(data.id)}
      okText='Yes'
      cancelText='No'
    >
      <Button danger style={{ maxWidth: 80 }} loading={isLoading}>
        Cancel
      </Button>
    </Popconfirm>
  )
}
